// @unocss-include
import type { SiteRouteItem } from '@/router/types';
import { PermissionPageKey } from '@/types/permission';
import Layout from '../components/layout/index.vue';

const route: SiteRouteItem = {
  path: '/project/:pkey',
  component: Layout,
  name: PermissionPageKey.Project,
  meta: {
    title: 'project.title',
    icon: 'fluent:share-screen-person-p-16-filled',
    iconCls: 'bg-blue-500',
  },
  children: [
    {
      path: 'dashboard',
      name: PermissionPageKey.ProjectDashboard,
      component: () => import('../pages/dashboard/index.vue'),
      meta: {
        title: 'project.dashboard.title',
        icon: 'material-symbols:dashboard',
      },
    },
    {
      path: 'dev',
      name: PermissionPageKey.ProjectDev,
      meta: {
        title: 'project.dev.title',
        icon: 'mdi:microsoft-visual-studio-code',
        roles: [
          'admin',
          'pm',
          'developer',
          'system-architect',
          'tester',
          'test-se',
          'iqc',
          'product',
          'dqe',
          'ui',
          'pqe',
          'test-od',
          'dev-od',
          'cqe',
          'leader',
          'pmo',
          'pt',
        ],
      },
      children: [
        {
          path: 'demand-management/:tab?',
          name: PermissionPageKey.ProjectDemandManage,
          component: () => import('../pages/dev/demand-management/index.vue'),
          meta: { title: 'project.dev.demand_management.title' },
        },
        {
          path: 'productDemandList-detail/:type/:id',
          name: PermissionPageKey.ProductAndUIDemandListDetail,
          component: () => import('../pages/dev/demand-management/components/product-and-ui-demand-detail.vue'),
          meta: {
            title: 'project.dev.product_demand_list_detail.title',
            hideInMenu: true,
          },
        },
        {
          path: 'productDemandAi/:id',
          name: PermissionPageKey.ProductDemandAI,
          component: () => import('../pages/dev/demand-viewer/index.vue'),
          meta: {
            title: 'project.dev.product_demand_ai.title',
            hideInMenu: true,
          },
        },
        {
          path: 'test-programme',
          name: PermissionPageKey.ProjectTestProgramme,
          component: () => import('../pages/dev/test-programme/index.vue'),
          meta: {
            title: 'project.dev.test_programme.title',
          },
        },
        {
          path: 'submit-test',
          name: PermissionPageKey.ProjectSubmitTest,
          component: () => import('../pages/dev/test-management/project-submit-for-testing/submit-for-testing.vue'),
          meta: {
            title: 'project.dev.submit_test.title',
            keepAlive: true,
          },
        },
        {
          path: 'test-plan',
          name: PermissionPageKey.ProjectTestPlan,
          component: () => import('../pages/dev/test-management/test-plan/test-plan.vue'),
          meta: {
            title: 'project.dev.test_plan.title',
          },
        },
        {
          path: 'test-plan/test-plan-detail/:project/:versionId?/:id?',
          name: PermissionPageKey.ProjectTestPlanDetail,
          component: () => import('../pages/dev/test-management/test-plan/detail.vue'),
          meta: {
            title: 'project.dev.test_plan_detail.title',
            hideInMenu: true,
          },
        },
        {
          path: 'test-plan/test-plan-report/:planId?',
          name: PermissionPageKey.ProjectTestPlanReport,
          component: () => import('../pages/dev/test-management/test-plan/plan-report.vue'),
          meta: {
            title: 'project.dev.test_plan_report.title',
            hideInMenu: true,
          },
        },
        {
          path: 'test-report',
          name: PermissionPageKey.ProjectTestReport,
          component: () => import('../pages/dev/test-management/test-report/test-report.vue'),
          meta: {
            title: 'project.dev.test_report.title',
          },
        },
        {
          path: 'test-management/test-report-detail/:tab/:id?',
          name: PermissionPageKey.ProjectTestReportDetail,
          component: () => import('../pages/dev/test-management/test-report/baseTestReportTemplate.vue'),
          meta: {
            title: 'project.dev.test_report_detail.title',
            hideInMenu: true,
          },
        },
        {
          path: 'test-management/test-record-detail/:project/:version',
          name: PermissionPageKey.ProjectTestRecordDetail,
          component: () =>
            import('../pages/dev/test-management/project-submit-for-testing/components/test-record-detail.vue'),
          meta: {
            title: 'project.dev.test_record_detail.title',
            hideInMenu: true,
          },
        },
        {
          path: 'auto-test',
          name: PermissionPageKey.ProjectAutoTest,
          component: () => import('../pages/dev/auto-test/index.vue'),
          meta: {
            title: 'project.dev.auto_test.title',
            hideInMenu: true,
          },
        },
        {
          path: 'testcase',
          name: PermissionPageKey.CloudtestTestCase,
          component: () => import('../pages/dev/testcase/index.vue'),
          meta: {
            title: 'project.dev.testcase.title',
          },
        },
        // {
        //   path: 'ort-test',
        //   name: PermissionPageKey.ProjectORTTest,
        //   component: () => import('../pages/dev/ort-test/submit-test.vue'),
        //   meta: { title: 'ORT测试', hideInSoftwareProject: true },
        // },
        // {
        //   path: 'ort-test-detail/:id',
        //   name: PermissionPageKey.ProjectORTTestReport,
        //   component: () => import('../pages/dev/ort-test/test-report.vue'),
        //   meta: {
        //     title: 'ORT测报告',
        //     hideInMenu: true,
        //     hideInSoftwareProject: true,
        //   },
        // },
      ],
    },
    {
      path: 'tr',
      name: PermissionPageKey.ProjectTRReview,
      meta: {
        title: 'project.tr.title',
        icon: 'ri:registered-line',
        hideInSoftwareProject: true,
      },
      children: [
        {
          path: 'old',
          name: PermissionPageKey.OldProjectTRReview,
          component: () => import('../pages/stage-review/index_new.vue'),
          meta: {
            title: 'project.tr.old.title',
            hideInSoftwareProject: true,
          },
        },
        // {
        //   path: 'new',
        //   name: PermissionPageKey.NewProjectTRReview,
        //   component: () => import('../pages/new-tr-review/index.vue'),
        //   meta: {
        //     title: '新转阶段评审(新)',
        //     icon: 'ri:registered-line',
        //     hideInSoftwareProject: true,
        //   },
        // },
        {
          path: 'standards-controlled',
          name: PermissionPageKey.StandardsControlled,
          component: () => import('../pages/new-tr-review/standards-controlled/index.vue'),
          meta: {
            title: 'project.tr.standards_controlled.title',
            hideInSoftwareProject: true,
          },
        },
        {
          path: 'new',
          name: PermissionPageKey.NewProjectTRReview,
          component: () => import('../pages/new-tr-review/standards-repository/index.vue'),
          meta: {
            title: 'project.tr.standards_repository.title',
            hideInSoftwareProject: true,
          },
        },
        {
          path: 'module',
          name: PermissionPageKey.ProjectTrModule,
          component: () => import('../pages/new-tr-review/standards-module/index.vue'),
          meta: {
            title: 'project.tr.standards_module.title',
            hideInSoftwareProject: true,
          },
        },
      ],
    },

    {
      path: 'tr/detail/:recordId',
      name: PermissionPageKey.ProjectTRReviewDetail,
      component: () => import('../pages/stage-review/components/review_page.vue'),
      meta: {
        title: 'project.tr_detail.title',
        hideInMenu: true,
      },
    },
    // {
    //   path: 'prototype-management',
    //   name: PermissionPageKey.ProjectPrototypeManagement,
    //   meta: {
    //     title: '样机管理',
    //     icon: 'ri:registered-line',
    //     hideInSoftwareProject: true,
    //   },
    //   children: [
    //     {
    //       path: 'list',
    //       name: PermissionPageKey.ProjectPrototypeList,
    //       component: () =>
    //         import('../pages/prototype-management/prototype-list/index.vue'),
    //       meta: { title: '样机列表' },
    //     },
    //     {
    //       path: 'test-report',
    //       name: PermissionPageKey.ProjectPrototypeTestReport,
    //       component: () =>
    //         import(
    //           '../pages/prototype-management/prototype-test-report/index.vue'
    //         ),
    //       meta: { title: '样机试装报告' },
    //     },
    //     {
    //       path: 'test-report-detail',
    //       name: PermissionPageKey.ProjectPrototypeTestReportDetail,
    //       component: () =>
    //         import(
    //           '../pages/prototype-management/prototype-test-report-detail/basePrototypeTestReportTemplate.vue'
    //         ),
    //       meta: { title: '样机试装报告详情', hideInMenu: true },
    //     },
    //   ],
    // },
    {
      path: 'inspect',
      name: PermissionPageKey.ProjectInspect,
      meta: {
        title: 'project.inspect.title',
        icon: 'mdi:clipboard-check-outline',
        hideInSoftwareProject: true,
      },
      children: [
        {
          path: 'inspection-checklist',
          name: PermissionPageKey.ProjectInspectionChecklist,
          component: () => import('../pages/inspect/inspection-checklist/index.vue'),
          meta: {
            title: 'project.inspect.inspection_checklist.title',
          },
        },
        {
          path: 'machine',
          name: PermissionPageKey.ProjectInspectMachine,
          component: () => import('../pages/inspect/whole-machine-checklist/index.vue'),
          meta: {
            title: 'project.inspect.whole_machine_checklist.title',
          },
        },
        {
          path: 'package',
          name: PermissionPageKey.ProjectInspectPackage,
          component: () => import('../pages/inspect/package/index.vue'),
          meta: {
            title: 'project.inspect.package.title',
          },
        },
        {
          path: 'package-auto',
          name: PermissionPageKey.ProjectInspectPackageAuto,
          component: () => import('../pages/inspect/package-auto-inspect/index.vue'),
          meta: {
            title: 'project.inspect.package_auto_inspect.title',
          },
        },
      ],
    },
    {
      path: 'inspect-standard',
      name: PermissionPageKey.ProjectInspectStandard,
      meta: {
        title: 'project.inspect_standard.title',
        icon: 'mdi:certificate-outline',
        hideInSoftwareProject: true,
      },
      children: [
        // {
        //   path: 'qcdrawing',
        //   name: PermissionPageKey.ProjectQCDrawing,
        //   component: () =>
        //     import('../pages/inspect-standard/qcdrawing/QCDrawing.vue'),
        //   meta: {
        //     title: 'project.inspect_standard.qcdrawing.title',
        //   },
        // },
        {
          path: 'process',
          name: PermissionPageKey.ProjectInspectStandardProcess,
          component: () => import('../pages/inspect-standard/ProcessInspectStandard.vue'),
          meta: {
            title: 'project.inspect_standard.process.title',
          },
        },
        {
          path: 'machine',
          name: PermissionPageKey.ProjectInspectStandardMachine,
          component: () => import('../pages/inspect-standard/MachineInspectStandard.vue'),
          meta: {
            title: 'project.inspect_standard.machine.title',
          },
        },
        {
          path: 'finish',
          name: PermissionPageKey.ProjectInspectStandardFinish,
          component: () => import('../pages/inspect-standard/FinishInspectStandard.vue'),
          meta: {
            title: 'project.inspect_standard.finish.title',
          },
        },
      ],
    },
    {
      path: 'issue',
      name: PermissionPageKey.ProjectIssue,
      meta: {
        title: 'project.issue.title',
        icon: 'mdi:bug',
      },
      children: [
        {
          name: PermissionPageKey.ProjectIssueList,
          path: 'list',
          meta: {
            title: 'project.issue.list.title',
            keepAlive: true,
          },
          component: () => import('../pages/issue/index.vue'),
        },
        {
          name: PermissionPageKey.ProjectIssueDetail,
          path: 'detail/:issueKey',
          meta: {
            title: 'project.issue.detail.title',
            hideInMenu: true,
          },
          component: () => import('../pages/issue/project-issue-detail.vue'),
        },
        {
          name: PermissionPageKey.ProjectIssueProductionMaterial,
          path: 'production-material',
          component: () => import('../pages/issue/production-material-issue.vue'),
          meta: {
            title: 'project.issue.production_material.title',
            hideInSoftwareProject: true,
          },
        },
        {
          name: PermissionPageKey.ProjectIssueProductionProcess,
          path: 'production-process',
          component: () => import('../pages/issue/production-process-issue.vue'),
          meta: {
            title: 'project.issue.production_process.title',
            hideInSoftwareProject: true,
          },
        },
        {
          name: PermissionPageKey.ProjectIssueTrialProduction,
          path: 'trial-production',
          component: () => import('../pages/issue/trial-production-issue.vue'),
          meta: {
            title: 'project.issue.trial_production.title',
            hideInSoftwareProject: true,
          },
        },
        {
          name: PermissionPageKey.ProjectIssueRisk,
          path: 'risk',
          component: () => import('../pages/issue/risk-issue.vue'),
          meta: {
            title: 'project.issue.risk.title',
          },
        },
      ],
    },
    {
      path: 'rr',
      name: PermissionPageKey.ProjectRR,
      meta: {
        title: 'project.rr.title',
        icon: 'game-icons:auto-repair',
        hideInSoftwareProject: true,
      },
      children: [
        {
          name: PermissionPageKey.ProjectRepairList,
          path: 'repair-list',
          component: () => import('../pages/repair/index.vue'),
          meta: {
            title: 'project.rr.repair_list.title',
          },
        },
        {
          name: PermissionPageKey.ProjectReworkList,
          path: 'rework-list',
          component: () => import('../pages/rework/index.vue'),
          meta: {
            title: 'project.rr.rework_list.title',
          },
        },
      ],
    },
    // {
    //   path: 'fixture-manage',
    //   name: PermissionPageKey.CloudtestProduceFixtureManage,
    //   component: () => import('../pages/produce/fixture-manage/index.vue'),
    //   meta: { title: '治具管理', icon: 'bi:tools', roles: ['admin'] },
    // },
    {
      path: 'setting',
      name: PermissionPageKey.ProjectSetting,
      meta: {
        title: 'project.setting.title',
        icon: 'ant-design:setting-filled',
      },
      children: [
        {
          path: 'components',
          name: PermissionPageKey.ProjectSettingComponents,
          component: () => import('../pages/setting/components/index.vue'),
          meta: {
            title: 'project.setting.components.title',
          },
        },
        {
          path: 'version',
          name: PermissionPageKey.ProjectSettingVersion,
          component: () => import('../pages/setting/version/index.vue'),
          meta: {
            title: 'project.setting.version.title',
          },
        },
        {
          path: 'product',
          name: PermissionPageKey.ProjectSettingProduct,
          component: () => import('../pages/setting/production/index.vue'),
          meta: {
            title: 'project.setting.production.title',
            hideInSoftwareProject: true,
          },
        },
        {
          path: 'tr',
          name: PermissionPageKey.ProjectSettingTR,
          component: () => import('../pages/setting/tr-node-config/index.vue'),
          meta: {
            title: 'project.setting.tr_node_config.title',
            hideInSoftwareProject: true,
          },
        },
        // 因为产品项目sku暂未被其他模版使用，所以隐藏，后续产品项目和sku的关系由k3维护和获取
        // {
        //   path: 'sku',
        //   name: PermissionPageKey.ProjectSettingSku,
        //   component: () => import('../pages/setting/sku/index.vue'),
        //   meta: { title: 'SKU', hideInSoftwareProject: true },
        // },
        {
          path: 'bom',
          name: PermissionPageKey.ProjectSettingBom,
          component: () => import('../pages/setting/bom/index.vue'),
          meta: {
            title: 'project.setting.bom.title',
            hideInSoftwareProject: true,
          },
        },
        {
          path: 'system',
          name: PermissionPageKey.ProjectSettingSystem,
          component: () => import('../pages/setting/system/index.vue'),
          meta: {
            title: 'project.setting.system.title',
          },
        },
      ],
    },
  ],
};

export default route;
